












import Debug from "@/components/Debug.vue";
import Modal from "@/components/modals/Modal.vue";
import IConfig from "@/typings/IConfig";
import { Component, Provide, Vue } from "vue-property-decorator";
import QueryWorker from "worker-loader!./QueryWorker";
import { eventBus, IModalPayload } from "./lib/event-bus";
import IMedia from "./typings/IMedia";

/**
 * The base application component.
 */
@Component({
  components: { Debug, Modal }
})
export default class App extends Vue {
  @Provide("queryWorker") private queryWorker = new QueryWorker();

  private attempts: number = 0;

  /**
   * The background-image source, based on route.
   */
  private get backgroundImage(): string {
    if (this.$route.name === "home")
      return require("@/assets/images/bg_map.png");
    return "unset";
  }

  private get CONFIG(): IConfig {
    return this.$store.getters.CONFIG;
  }

  private get isDebug(): string | undefined {
    return process.env.VUE_APP_DEBUG;
  }

  /**
   * Handles incoming messages from the Query web worker.
   */
  private handleQueryWorkerMessage(): void {
    this.queryWorker.addEventListener("message", (event: MessageEvent) => {
      switch (event.data.type) {
        case "question":
          this.$store.dispatch("updateQuestions", event.data.questions.data);
          break;
        case "avatar":
          this.$store.dispatch("updateAvatarList", event.data.avatars.data);
          break;
        case "media":
          const media = event.data.media.data as IMedia[];
          media.forEach(m => {
            const h = `${process.env.VUE_APP_API_URI}${m.url}`;
            prefetchAsset(h);
          });
        default:
          break;
      }
    });
  }

  private beforeMount(): void {
    this.handleQueryWorkerMessage();
  }
}

/**
 * prefetchAsset prefetches an asset, such as an image, and loads it into cache
 * storage.
 */
const prefetchAsset = (href: string) => {
  const link = document.createElement("link");
  link.rel = "prefetch";
  link.href = href;
  document.head.appendChild(link);
};
